<template>
    <rkm-layout-body title="Lista de material">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-material-create' })"
                color="primary"
                authorize="store-cadastro-material"
            >
                Cadastrar material
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/cadastro/material/List'

export default {
    components: { List },
}
</script>